(() => {
  let previousFocus;
  let previousOverflow = '';
  const dialog = () => document.getElementById('custom-upsell-modal');
  const close = () => {
    const modal = dialog();
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.style.overflow = previousOverflow;
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    document.querySelector('cart-drawer')?.close();
    previousFocus?.focus();
  };
  const open = () => {
    const modal = dialog();
    if (!modal || !modal.querySelector('[data-upsell-card]') || !modal.hidden) return;
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    const closeButton = modal.querySelector('[data-upsell-close]');
    if (typeof trapFocus === 'function') trapFocus(modal, closeButton);
    else closeButton.focus();
  };
  document.addEventListener('fff:product-added', (event) => {
    if (event.detail?.isUpsell) {
      const card = event.target.closest('[data-upsell-card]');
      if (card) card.querySelector('.friendly-upsell__item-status').textContent = 'Added to your cart ✓';
      return;
    }
    // Electronic gift cards already collect their recipient details on the product page.
    if (event.target.querySelector('recipient-form')) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open(document.getElementById('cart-icon-bubble'));
      return;
    }
    open();
  });
  document.addEventListener('click', (event) => {
    const modal = dialog();
    const deliveryCartButton = event.target.closest('[data-open-delivery-cart]');
    if (deliveryCartButton) {
      event.preventDefault();
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open(deliveryCartButton);
      return;
    }
    if (!modal) return;
    if (event.target.closest('[data-upsell-close]') || event.target === modal) close();
    if (event.target.closest('.gcb-cart-open')) open();
    const cartButton = event.target.closest('[data-upsell-cart]');
    if (cartButton) {
      close();
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open(document.getElementById('cart-icon-bubble'));
    }
  });
  document.addEventListener('keydown', (event) => {
    const modal = dialog();
    if (event.key === 'Escape' && modal && !modal.hidden) {
      event.preventDefault();
      event.stopImmediatePropagation();
      close();
    }
  }, true);
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-upsell-variant]')) return;
    const card = event.target.closest('[data-upsell-card]');
    const option = event.target.selectedOptions[0];
    const available = option.dataset.available === 'true';
    card.querySelector('input[name="id"]').value = option.value;
    card.querySelector('.upsell-price').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
      style: 'currency', currency: dialog().dataset.currency || 'AUD'
    }).format(Number(option.dataset.price) / 100);
    const button = card.querySelector('button[name="add"]');
    button.disabled = !available;
    button.removeAttribute('aria-disabled');
    button.querySelector('span').textContent = available ? 'Add to cart' : 'Sold out';
    card.querySelector('.friendly-upsell__item-status').textContent = '';
  });
})();
